import {
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  Text
} from '@chakra-ui/react';
import { IoMdSearch } from 'react-icons/io';
import { FiUpload } from 'react-icons/fi';
import { PageTransition } from '../../../../components/PageTransition';

export function FotoPedidoStep() {
  return (
    <PageTransition>
      <Flex flexDir="column" bg="white">
        <Flex px={3} alignItems="center" justifyContent="center" py="27px">
          <InputGroup>
            <InputLeftAddon children="Pedido" borderRadius={0} />
            <Input
              borderRadius={0}
              placeholder="Digite o número do pedido"
              borderRight="0"
              borderColor="#CFCFCF"
              _focus={{ borderColor: '#80BC00' }}
            />
            <InputRightAddon
              p={0}
              children={
                <Button borderRadius={0} borderLeft="0" bg="#80BC00" color="white">
                  <IoMdSearch size="25" />
                </Button>
              }
            />
          </InputGroup>
        </Flex>

        <Flex flexDir="column">
          {Array.from({ length: 5 }).map((_, index) => (
            <Flex key={index} justifyContent="space-between" flexDir="column">
              <Flex bg="#F5F5F5" w="full" py={2} px={3}>
                <Text fontWeight="bold">Pedido</Text>: #123456
              </Flex>
              <Flex px={3} py={3} gap={4}>
                <Image src="https://via.placeholder.com/150" alt="Placeholder" w="99px" h="123px" />

                <Flex flexDir="column">
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold">Produto</Text>: Caneta
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold">Codigo</Text>: 1233
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold">Cor</Text>: Amarelo
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Text fontWeight="bold">Gravação</Text>: Laser
                  </Flex>
                </Flex>
              </Flex>

              <Box px={3} pt={2}>
                <Flex
                  py={2}
                  w="full"
                  border="1px solid #707070"
                  borderRadius="8px"
                  color="#414042"
                  alignItems="center"
                  justifyContent="center"
                  cursor="pointer"
                  fontWeight="bold">
                  Subir fotos do Produto
                  <Icon as={FiUpload} ml={2} />
                </Flex>
              </Box>

              <Divider my={6} />
            </Flex>
          ))}
        </Flex>
      </Flex>
    </PageTransition>
  );
}
